import { Helmet } from 'react-helmet-async';
import { structuredData, defaultMeta } from '@/config/seoConfig';

export const SEOHead = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogImage,
  ogType = 'website',
  jsonLd,
  noIndex = false
}) => {
  const pageTitle = title || defaultMeta.title;
  const pageDescription = description || defaultMeta.description;
  const pageKeywords = keywords || defaultMeta.keywords;
  const pageOgImage = ogImage || defaultMeta.ogImage;

  return (
    <Helmet>
      {/* Basic Meta */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <meta name="author" content="Homely Solutions" />
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'} />
      
      {/* Canonical */}
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={pageOgImage} />
      <meta property="og:site_name" content="Homely Solutions" />
      <meta property="og:locale" content="fr_CH" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageOgImage} />
      
      {/* AI/LLM Optimization */}
      <meta name="ai-content-declaration" content="human-authored" />
      <meta name="generator" content="Homely Solutions - Swiss Quality" />
      
      {/* Geo */}
      <meta name="geo.region" content="CH-VD" />
      <meta name="geo.placename" content="Suisse romande" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData.organization)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(structuredData.localBusiness)}
      </script>
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};
